<template>
  <tr :class="conditionType" v-if=isShow>
    <td class="name">{{item.middleName}}</td>
    <td class="num">{{quantityList.lastDelivery}}</td>
    <td class="num">{{quantityList.stock}}</td>
    <td class="num">{{quantityList.loss}}</td>
    <td class="num">{{quantityList.recall}}</td>
    <td class="num">{{quantityList.prepare}}</td>
    <td class="num">{{quantityList.takeout}}</td>
    <td class="num">{{quantityList.actualDelivery}}</td>
    <td class="num">{{quantityList.deliveryResult}}</td>
    <td class="num">{{quantityList.sales}}</td>
  </tr>
</template>


<script>
  export default {
    name: 'ReportTableRow',
    props: {
      item: {},
      conditionType: String,
    },
    computed: {
      quantityList() {
        return this.$store.getters.quantityList(this.item.itemId);
      },
      isShow() {
        return (
          this.quantityList.lastDelivery > 0 ||
          this.quantityList.prepare > 0 ||
          this.quantityList.stock > 0 ||
          this.quantityList.takeout > 0
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  $base_col_width: 8%;

  tbody {
    td {
      width: $base_col_width;

      &.col2 {
        width: $base_col_width * 2;
      }

      &.name {
        width: 28%;
      }
    }

    > tr {
      &.normal-temperature {
        background: #FDEAEA;

        &:nth-of-type(even) {
          background: #FBC6C6;
        }
      }

      > td {
        &.num {
          text-align: right;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/ReportTableRow.vue?38894c52